<template>
	<div>
		<table class="datatable">
			<thead v-if="!isMobile">
			<th class="sortable active left" @click="sort('name')">
				Gruppenavn
			</th>
			</thead>
			<tbody v-if="!isMobile">
				<tr v-for="(persongroup, index) in (sortedActivity, filteredList)" :key="index" @click="showPersonGroup(persongroup)">
					<td v-text="persongroup.name"></td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr v-for="(persongroup, index) in (sortedActivity, filteredList)" :key="index" @click="showPersonGroup(persongroup)">
					<td>
						<ul class="flex-content">
							<li data-label="Gruppenavn">{{ persongroup.name }}</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-if="(data && data.length > 0) && (filteredList && filteredList.length == 0) && !isComponentBusy">
			Ingen grupper fundet
		</div>
		<div v-if="(data == null || data.length == 0) && !isComponentBusy">
			Der er endnu ikke oprettet nogen grupper
		</div>
		<transition name="fade">
			<div class="busyloader" v-if="isComponentBusy"><div><div></div><div></div><div></div><div></div></div></div>
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types";

	export default {
		name: "PersonGroupsList",
		data: () => ({
			data: [],
			customerID: null,
			agreementID: null,
			currentSort: "name",
			currentSortDir: "asc",
			searchSelection: "",
			pageSize: 10000,
			currentPage: 1
		}),
		props: ["search", "section", "selection", "agreementidref"],
		computed:
		{
			isMobile()
			{
				return this.$mq !== "tablethori" && this.$mq !== "desktop"
			},
			sortedActivity: function ()
			{
				// TODO: Refactor til https://vuejs.org/v2/examples/grid-component.html
				var persongroups = this.data
				return persongroups.sort((a, b) =>
				{
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			},
			filteredList()
			{
				var persongroups = this.data
				return persongroups.filter((data) =>
				{
					let name = data.name.toLowerCase().match(this.search.toLowerCase());
					return name;
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
			}
		},
		beforeUpdate()
		{
			this.$emit("update", { groupname: null })
		},
		mounted()
		{
			this.customerID = this.$route.params.customerid
			this.agreementID = this.$route.params.agreementid

			if (!this.agreementID || this.agreementID == 0)
			{
				this.agreementID = this.agreementidref
			}

			this.loadData()
		},
		methods:
		{
			getGroupNameAndType(persongroup)
			{
				switch (persongroup.type)
				{
					case 2:
						return "Klasse: " + persongroup.name
						break;
					case 3:
						return "Stue: " + persongroup.name
						break;
					case 4:
						return "Medarbejdere: " + persongroup.name
						break;
					default:
						return persongroup.name
				}

			},
			async loadData()
			{
				this.setComponentAsBusy()
				let data = { customerid: this.customerID, agreementid: this.agreementID }
				await this.$store.dispatch(types.ACTION_GET_PERSONGROUPS, data)
					.then(response =>
					{
						this.data = response.data;
						for (let persongroup of this.data)
						{
							persongroup.originalname = persongroup.name
							persongroup.name = this.getGroupNameAndType(persongroup)
						}
						this.setComponentAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("PersonGroupsList.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
					});
			},
			showPersonGroup(persongroup)
			{
				if (!this.section || this.section == "customer")
				{
					this.$router.push({ name: "PersonGroupShow", params: { customerid: this.customerID, persongroupid: persongroup.id } })
				}
				else if (this.section == "orders")
				{
					this.$emit("update", { groupname: persongroup.originalname })
					this.$router.push({ name: "OrdersPersonGroupShow", params: { agreementid: this.agreementID, customerid: this.customerID, persongroupid: persongroup.id } })
				}
			},
			sort: function (s)
			{
				if (s === this.currentSort)
				{
					this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
				}
				this.currentSort = s;
			},
			nextPage: function ()
			{
				if ((this.currentPage * this.pageSize) < this.data.length) this.currentPage++;
			},
			prevPage: function ()
			{
				if (this.currentPage > 1) this.currentPage--;
			}
		}
	}
</script>
